import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';

export function useLayoutBranchDesktop(): boolean {
  const theme = useTheme();
  const [locked] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia(`(min-width:${theme.breakpoints.values.lg}px)`).matches,
  );
  return locked;
}

export function useResponsive() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  return {
    theme,
    isDesktop,
    isTablet,
    isMobile: !isDesktop,
  };
}
